import {
  deleteAllNotifications,
  deleteAllReadNotifications,
  deleteNotification,
  readAllNotifications,
  readNotification,
  unreadNotification,
} from '@/pages/api/scribeAPIV2';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_NOTIFICATIONS } from '../query/useQueryNotifications';

export const useMutateReadAllNotifications = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => readAllNotifications(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};

export const useMutateDeleteAllNotifications = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deleteAllNotifications(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};

export const useMutateDeleteAllReadNotifications = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deleteAllReadNotifications(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};

export const useMutateDeleteNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) => deleteNotification(notificationId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};

export const useMutateReadNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) => readNotification(notificationId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};

export const useMutateUnreadNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) => unreadNotification(notificationId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};
